import { useState } from 'react';
import { Alert, Text, Link, Box } from '@nimbus-ds/components';
import ShowByTag from 'App/components/ShowByTag';
import { DOMAIN_DISCONNECTED } from 'App/featuresFlags';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';

export default function DomainDisconnectedAlert() {
  const [show, setShow] = useState(true);
  const t = useTranslationDashboard('domainDisconnectedAlert');
  if (!show) return null;
  return (
    <ShowByTag tag={DOMAIN_DISCONNECTED}>
      <Alert
        appearance="danger"
        show={show}
        onRemove={() => setShow(false)}
        title={t('title')}
      >
        <Box marginBottom="2">
          <Text as="span">{t('description')}</Text>
        </Box>
        <Box>
          <Link as="a" href={t('helpLink')} target="_blank">
            {t('helpText')}
          </Link>
        </Box>
      </Alert>
    </ShowByTag>
  );
}
